import React, { useState } from "react";

import facebookFooter from "../../../assets/icons/facebookFooter.svg";
import instagramFooter from "../../../assets/icons/instagramFooter.svg";
import facebookGroup from "../../../assets/icons/facebookGroup.svg";
import moveoLogo from "../../../assets/icons/moveoLogo.svg";
import veidatHatviotLogo from "../../../assets/icons/veidat_hatviot_logo.png"
import evzFoundation from "../../../assets/icons/evz-foundation.png"
import ministryOfFinance from "../../../assets/icons/ministry-of-finance.png"
import clearSearch from "../../../assets/icons/clearSearch.svg";

import { useTranslation } from "react-i18next";
import {
  FooterContainer,
  LinksContainer,
  InlineDiv,
  LinkColor,
  InlineDivFlexStart,
  IconImg,
  LinkBold,
  MoveoLogoContainer,
  DivFlexReverse,
  MoveoLogoImg,
  VeidatHatviotLogoImg,
  IconContainer,
  IconImgFaceBookGroup,
  IconImgInstagram,
  FooterLink,
  ExitModalDiv,
  FooterSupportedText,
} from "./footerStyle";
import i18n from "../../../i18n";
import useGenericModal from "../Modal/useGenericModal";
import PolicyTermsHeb from "../../Auth/Register/RegisterForm/PolicyTerms/Heb";
import PrivacyPolicyHeb from "../../Auth/Register/RegisterForm/PrivacyPolicy/Heb";
import PolicyTermsEng from "../../Auth/Register/RegisterForm/PolicyTerms/Eng";
import PrivacyPolicyEng from "../../Auth/Register/RegisterForm/PrivacyPolicy/Eng";
import getDirection from "../../../utils/getLanguageDirection";
import * as salonsSelector from "../../../store/selectors/salonsSelectors";
import { useSelector } from "react-redux";
import contactUsUrl from "../../../utils/constants/siteUrls";
import useTermsModal from "../Modal/useTermsModal";
import { ImageContainer } from "../../Auth/Register/RegisterForm/RegisterFormStyle";
import { buildPath, routes } from "../../../utils/constants/routes";
import history from "../../../history";

const Footer: React.FC = () => {
  const { t , i18n: { language }} = useTranslation();
 
  const langDirection = getDirection();
  const [modalToOpen, setModalToOpen] = useState<"privacy" | "terms">(null);

  const [ModalPrivacy, isModalOpenPrivacy, openModalPrivacy, closeModalPrivacy] = useGenericModal();
  const [ModalTerms, isModalOpenTerms, openModalTerms, closeModalTerms] = useTermsModal();
  const navigateToAccessibility = () => history.push(buildPath(routes.accessibilityPage.root));
  const isIOSModalOpen = useSelector(salonsSelector.isIOSModalOpenSelector);

  const handlePrivacyModalOpen = () => {
    openModalPrivacy({
      options: {
        style: {
          width: "30%",
          height: "774px",
          top: "calc(21% - 120px)",
          padding: "10px 20px",
          border: "none",
          borderRadius: "6px 6px 6px 6px",
          zIndex: 1,
        },
      },
      cbCancel: () => closeModalPrivacy(),
    });
  };

  const handleTermsModalOpen = () => {
    openModalTerms({
      options: {
        style: {
          width: "30%",
          height: "774px",
          top: "calc(21% - 120px)",
          padding: "10px 20px",
          border: "none",
          borderRadius: "6px 6px 6px 6px",
          zIndex: 1,
        },
      },
      cbCancel: () => closeModalTerms(),
    });
  };

  return (
    <FooterContainer lng={i18n.language} isIOSModalOpen={isIOSModalOpen}>
      <DivFlexReverse>
        <LinksContainer>
          <InlineDiv>
            <LinkBold
              style={{marginInlineEnd: '10px'}}
              align={langDirection === "rtl" ? "right" : "left"}
              isBorder="true"
              href= {language === "he" ? 'https://www.zikaronbasalon.com/צרו-קשר/' : 'https://www.zikaronbasalon.com/en/contact/'}
              rel="noopener noreferrer"
              target="_blank"
            >
              {t("footer.contact")}
            </LinkBold>
            <LinkColor
              align={langDirection === "rtl" ? "right" : "left"}
              isBorder="true"
              href= {language === "he" ? "https://www.zikaronbasalon.com/" : "http://www.zikaronbasalon.com/en/"}
              rel="noopener noreferrer"
              target="_blank"
            >
              {t("footer.zikronSite")}
            </LinkColor>
            <LinkColor
              onClick={() => handleTermsModalOpen()}
              align={langDirection === "rtl" ? "right" : "left"}
              isBorder="true"
            >
              {t("footer.terms")}
            </LinkColor>
            <LinkColor
              align={langDirection === "rtl" ? "right" : "left"}
              onClick={navigateToAccessibility}
            >
              {t("footer.accessibility")}
            </LinkColor>
          </InlineDiv>
        </LinksContainer>
        <IconContainer>
          <a
            href="https://www.facebook.com/groups/zikron/ "
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconImgFaceBookGroup src={facebookGroup} alt="facebookGroupe" />
          </a>
          <a
            href="https://www.facebook.com/ZikaronBaSalon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconImg src={facebookFooter} alt="facebookIcon" />
          </a>
          <a
            href="https://www.instagram.com/zikaronbasalon/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconImgInstagram src={instagramFooter} alt="instagram" />
          </a>
        </IconContainer>
      </DivFlexReverse>
      <MoveoLogoContainer lng={i18n.language}>
        <a
          href="https://moveo.group/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <MoveoLogoImg
            lng={i18n.language}
            src={moveoLogo}
            alt="moveo web & mobile"
          />
        </a>
        <VeidatHatviotLogoImg
            lng={i18n.language}
            src={veidatHatviotLogo}
            alt="claims conference"
          />
        <VeidatHatviotLogoImg
            lng={i18n.language}
            src={evzFoundation}
            alt="EVZ foundation"
          />
        <VeidatHatviotLogoImg
            lng={i18n.language}
            src={ministryOfFinance}
            alt="ministry of finance"
          />
          <FooterSupportedText>
          supported by the claims conference sponsored by the BMF
          </FooterSupportedText>
          <div></div>
      </MoveoLogoContainer>
      {isModalOpenPrivacy && (
          <ModalPrivacy className="policy-modal">
            {i18n.language === 'he' ? <PrivacyPolicyHeb /> : <PrivacyPolicyEng />}
          </ModalPrivacy>
        )}
      {isModalOpenTerms && (
          <ModalTerms className="policy-modal">
            <ImageContainer onClick={closeModalTerms}>
              <img style={{cursor: 'pointer'}} src={clearSearch} alt="exit" />
            </ImageContainer>
            {i18n.language === 'he' ? <PolicyTermsHeb /> : <PolicyTermsEng />}
          </ModalTerms>
        )}
    </FooterContainer>
  );
};

export default Footer;
